module.exports = __webpack_public_path__ + "assets/images/project/myanmar-desktop.jpg?v=00caf324";